import { ActivatedRoute, convertToParamMap } from "@angular/router";
import {
  HostListener,
  Component,
  OnInit,
  Output,
  AfterContentChecked,
  Input,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";

import { ErrorObject } from "../../app/errorhandler/gpiserror-object";
import { ErrorHandlerService } from "../../app/errorhandler/gpiserror-handler.service";
import { IReturnObject } from "../shared/return-object.model";
import { ErrorTypeEnum, StatusEnum } from "../shared/enums.model";
import { AttributeListBE, MaterialCompositionBE } from "../shared/attribute-list.model";
import { PackagingMaterialBE, MaterialSupplierBE } from "./shared/packaging-material.model";
import { ComponentCanDeactivate } from "../../app/shared/page.pendingchangesguard";
import { PackageInstructionAdditionalMHBE } from "../../app/packaging-instruction/shared/packaging-instruction-material.model";
import { PackagingMaterialService } from "./packaging-material.service";
import { SupplierService } from "../../app/supplier/supplier.service";
import { SupplierListBE } from "../../app/supplier/shared/supplier.model";
import { UserHandling } from "../shared/user-handling";
import { ButtonBarComponent } from "../guicomponents/buttonbar/buttonbar.component";
import { PictureBe } from "../../app/image-library/shared/image-model";
import { ImageCommon } from "../image-library/image-common";
import { ConfirmResult } from "../../app/dialogboxes/shared/confirm.model";
import { PackagingMaterialSearchDlgComponent } from "../../app/packaging-material/search-packaging-material.component";
import { PackagingMaterialListBE } from "../../app/packaging-material/shared/packaging-material.model";
import { SetFocus } from "../../app/shared/setFocus";
import { AppConfig } from "../../app/config/app.config";
import { PackagingMaterialAttirbuteService } from "../packaging-material-attributes/packaging-material-attributes.service";


declare var jQuery: any;

const MIN_NAME_LENGTH = 2;

@Component({
  moduleId: module.id,
  selector: "packaging-material",
  templateUrl: "packaging-material.html",
  providers: [PackagingMaterialService, SupplierService, PackagingMaterialAttirbuteService],
})
export class PackagingMaterialComponent
  implements OnInit, AfterContentChecked, ComponentCanDeactivate {
  @Input() materialIdFromParentCtrl: number;

  isDirty: boolean = false;
  errorObj: ErrorObject = null;
  material: PackagingMaterialBE = null;
  isEditMode: boolean = false;
  selectedMaterialId: number;
  showMaterialSearchSpinner: boolean = false;
  showSpinner: boolean = false;
  showLoadAttributeListsSpinner: boolean = false;

  // Lists
  consumingAreasList: AttributeListBE[] = [];
  dispatchersList: AttributeListBE[] = [];
  mainStoresList: AttributeListBE[] = [];
  receiversList: AttributeListBE[] = [];
  washingSuppliersList: AttributeListBE[] = [];
  storageConditionList: AttributeListBE[] = [];
  supplierList: SupplierListBE[];

  packagingTypesList: AttributeListBE[] = [];
  returnablesList: AttributeListBE[] = [];
  packagingOwnersList: AttributeListBE[] = [];
  classificationsList: AttributeListBE[] = [];
  regionsList: AttributeListBE[] = [];
  materialCompositionList: MaterialCompositionBE[] = [];

  tmpPackagingTypesList: AttributeListBE[] = [];
  tmpReturnablesList: AttributeListBE[] = [];
  tmpPackagingOwnersList: AttributeListBE[] = [];
  tmpClassificationsList: AttributeListBE[] = [];
  tmpRegionsList: AttributeListBE[] = [];
  tmpstorageConditionList: AttributeListBE[] = [];
  tmpMaterialsList: AttributeListBE[] = [];
  tmpMaterialsCompositionList: MaterialCompositionBE[] = [];

  tmpConsumingAreasList: AttributeListBE[] = [];
  tmpDispatchersList: AttributeListBE[] = [];
  tmpMainStoresList: AttributeListBE[] = [];
  tmpReceiversList: AttributeListBE[] = [];
  tmpWashingSuppliersList: AttributeListBE[] = [];

  // Image
  image1: any;
  imageLibraryEvent: PictureBe;
  addImageDlg: NgbModalRef;
  pictureLabels: string = "";
  imageSearchResult: PictureBe[] = [];
  selectedImages: Array<number> = [];
  pictureIdS: Array<number> = [];
  deleteImageInfo: PictureBe;
  @Output() piImageId: Array<number> = [];

  // Button bar
  btnDuplicateVisible: boolean = true;
  btnNewVisible: boolean = true;
  btnActivateVisible: boolean = true;
  btnPreviewVisible: boolean = true;
  btnSaveVisible: boolean = true;
  btnApproveVisible: boolean = false;
  btnHistoryVisible: boolean = false;
  btnDeleteVisible: boolean = true;

  // Supplier search handling
  supplierSearchListDelayTimer: any = null;
  searchListDelayTimerDelay: number = 250;
  viewSupplierList: boolean = false;
  viewSupplierListSpinner: boolean = false;
  searchKeyStrokeDelay: number = 350;
  typeDelayTimer: any = null;
  selectedSupplier: SupplierListBE = null;
  searchSupplierText: string = "";

  // misc
  user: UserHandling = new UserHandling();
  newMaterialText: string = null;
  MHNOName: string = "";
  MHNOControlNameToSet: string = "";
  pendingAction: any = null;

  // confirm dialog
  @ViewChild("cDlg") cdlg: ElementRef;
  dialogAction: string;
  dialogBtnType: string;
  dialogAppliesTo: string = "";
  dialogAppliesToId: number = -1;
  confirmDlgText: string = "";
  currentDlg: NgbModalRef;

  // is material unique
  orgName: string = "";
  nameExistsClass: string = "";

  setFocus: SetFocus = new SetFocus();
  isFocusSet: boolean = false;

  materialsList: AttributeListBE[] = [];
  materialCompList: MaterialCompositionBE[] = [];
  materialId: number = 0;
  materialDescription: string = "";
  materialWeight: number = 0;
  sum: number = 0;
  estimatedco2weight: number = 0;
  co2Impactperkg: number = 0;
  materialDisabled: boolean = false;
  weightDisabled: boolean = false;

  constructor(
    private materialService: PackagingMaterialService,
    private modalService: NgbModal,
    private supplierService: SupplierService,
    private config: AppConfig,
    private _route: ActivatedRoute,
    private errHandler: ErrorHandlerService
  ) {
    errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err));
  }

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return !this.isDirty;
  }

  ngOnInit(): void {
    this.showMaterialSearchSpinner = true;
    var id = +this._route.snapshot.params["materialId"];
    if (isNaN(id) || id < 1) {
      if (!isNaN(this.materialIdFromParentCtrl) || id > 0)
        id = this.materialIdFromParentCtrl;
      else {
        this.materialIdFromParentCtrl = null;
        this.showSpinner = false;
      }
    }

    id > 0 ? this.getMaterial(id) : (id = null);

    this.getClassifications();
    this.getConsumingAreas();
    this.getDispatchers();
    this.getMainStores();
    this.getPackagingOwners();
    this.getPackagingTypes();
    this.getReceivers();
    this.getRegions();
    this.getReturnables();
    this.getWashingSuppliers();
    this.getStorageConditions();
    this.getMaterialList();
  }

  ngAfterContentChecked() {
    this.isFocusSet = this.setFocus.to("mhno", this.isFocusSet);
  }

  onError(error: ErrorObject) {
    this.errorObj = this.errHandler.getError();
  }

  setEditMode(editMode: boolean) {
    if (this.isDirty) {
      var confirmed = confirm(
        "You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes."
      );
      if (confirmed) {
        this.isDirty = false;
        this.isEditMode = editMode;
      }
    } else {
      this.material = null;
      this.isEditMode = editMode;
    }
  }

  allListsLoaded() {
    let isLoaded =
      this.packagingTypesList.length > 0 &&
      this.returnablesList.length > 0 &&
      this.packagingOwnersList.length > 0 &&
      this.classificationsList.length > 0 &&
      this.regionsList.length > 0 &&
      this.consumingAreasList.length > 0 &&
      this.dispatchersList.length > 0 &&
      this.mainStoresList.length > 0 &&
      this.receiversList.length > 0 &&
      this.storageConditionList.length > 0;
    this.washingSuppliersList.length > 0;
    this.showLoadAttributeListsSpinner = !isLoaded;
    return isLoaded;
  }

  resetTmpArrayes(): void {
    this.tmpPackagingTypesList = [];
    this.tmpReturnablesList = [];
    this.tmpPackagingOwnersList = [];
    this.tmpClassificationsList = [];
    this.tmpRegionsList = [];
    this.tmpstorageConditionList = [];
    this.tmpMaterialsList = [];
    this.tmpMaterialsCompositionList = [];

    this.tmpConsumingAreasList = [];
    this.tmpDispatchersList = [];
    this.tmpMainStoresList = [];
    this.tmpReceiversList = [];
    this.tmpWashingSuppliersList = [];

    this.packagingTypesList.forEach((x) => this.tmpPackagingTypesList.push(x));
    this.returnablesList.forEach((x) => this.tmpReturnablesList.push(x));
    this.packagingOwnersList.forEach((x) =>
      this.tmpPackagingOwnersList.push(x)
    );
    this.classificationsList.forEach((x) =>
      this.tmpClassificationsList.push(x)
    );
    this.regionsList.forEach((x) => this.tmpRegionsList.push(x));
    this.materialsList.forEach((x) => this.tmpMaterialsList.push(x));
    this.materialCompList.forEach((x) => this.tmpMaterialsCompositionList.push(x));
    this.storageConditionList.forEach((x) =>
      this.tmpstorageConditionList.push(x)
    );

    this.consumingAreasList.forEach((x) => this.tmpConsumingAreasList.push(x));
    this.dispatchersList.forEach((x) => this.tmpDispatchersList.push(x));
    this.mainStoresList.forEach((x) => this.tmpMainStoresList.push(x));
    this.receiversList.forEach((x) => this.tmpReceiversList.push(x));
    this.washingSuppliersList.forEach((x) =>
      this.tmpWashingSuppliersList.push(x)
    );
  }

  onSearchMaterialExecute(materialId: number) {
    this.showMaterialSearchSpinner = true;
    this.selectedMaterialId = materialId;
    this.getMaterial(materialId);
    this.setEditMode(true);
  }

  getMaterial(materialId: number) {
    this.errHandler.emitErrorObject(null);
    this.setEditMode(true);
    this.materialService
      .getMaterial(materialId)
      .subscribe((returnObject) => this.getMaterialResponse(returnObject));
  }

  getMaterialResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.searchMaterialResponse",
        returnObject.ErrorType
      );
    else this.setLoadedValues(returnObject);

    this.showMaterialSearchSpinner = false;
  }

  setLoadedValues(returnObject: IReturnObject) {
    this.selectedMaterialId = returnObject.DataList[0].Id;
    this.material = <PackagingMaterialBE>returnObject.DataList[0];
    this.material.Suppliers = <MaterialSupplierBE[]>(
      returnObject.DataList[0].Suppliers
    );

    this.materialCompList = <MaterialCompositionBE[]>(
      returnObject.DataList[0].MaterialCompositions
    );

    this.resetTmpArrayes();

    if (
      this.material.ResponsibleUserId == null ||
      this.material.ResponsibleUserId.length < 6
    ) {
      this.material.ResponsibleUserId = this.user.UserId;
      this.material.ResponsibleUserName = this.user.UserName;
      this.material.ResponsibleEmail=this.user.Email;
      this.material.ResponsibleUserDepartment = this.user.Department;
    }

    this.extractImages();

    this.pushInactiveItemToList(
      this.tmpPackagingTypesList,
      this.material.PackagingTypeId,
      this.material.PackagingTypeDescription
    );
    this.pushInactiveItemToList(
      this.tmpReturnablesList,
      this.material.ReturnableId,
      this.material.ReturnableDescription
    );
    this.pushInactiveItemToList(
      this.tmpPackagingOwnersList,
      this.material.PackagingOwnerId,
      this.material.PackagingOwnerDescription
    );
    this.pushInactiveItemToList(
      this.tmpClassificationsList,
      this.material.MaterialClassificationId,
      this.material.ClassificationDescription
    );
    this.pushInactiveItemToList(
      this.tmpRegionsList,
      this.material.RegionId,
      this.material.RegionDescription
    );
    this.pushInactiveItemToList(
      this.tmpstorageConditionList,
      this.material.StorageConditionId,
      this.material.StorageCondDescription
    );

    this.setSelectedListItems(
      this.tmpConsumingAreasList,
      this.material.ConsumingAreas
    );
    this.setSelectedListItems(
      this.tmpDispatchersList,
      this.material.Dispatchers
    );
    this.setSelectedListItems(this.tmpMainStoresList, this.material.MainStores);
    this.setSelectedListItems(this.tmpReceiversList, this.material.Receivers);
    this.setSelectedListItems(
      this.tmpWashingSuppliersList,
      this.material.WashingSuppliers
    );

    //check for issuer approver
    if (
      returnObject.DataList[0].InitialCreatorUserId != "" &&
      returnObject.DataList[0].InitialCreatorUserName == "-" &&
      returnObject.DataList[0].InitialCreatorUserDepartment == "-"
    )
      this.errHandler.emitError(
        "Initial Creator " +
        returnObject.DataList[0].InitialCreatorUserId.toUpperCase() +
        " doesnt exists in AD, Kindly raise a issue through Customer support to replace user " +
        returnObject.DataList[0].InitialCreatorUserId.toUpperCase() +
        " in PackIT.",
        "",
        ErrorTypeEnum.Error
      );

    if (
      returnObject.DataList[0].ResponsibleUserId != "" &&
      returnObject.DataList[0].ResponsibleUserName == "-" &&
      returnObject.DataList[0].ResponsibleUserDepartment == "-"
    )
      this.errHandler.emitError(
        "Responsible User " +
        returnObject.DataList[0].ResponsibleUserId.toUpperCase() +
        " doesnt exists in AD, Kindly raise a issue through Customer support to replace user " +
        returnObject.DataList[0].ResponsibleUserId.toUpperCase() +
        " in PackIT.",
        "",
        ErrorTypeEnum.Error
      );

    this.newMaterialText = null;
    this.orgName = this.material.MHNo;
    this.nameExistsClass = "";
    this.isDirty = false;
    this.showSpinner = false;
  }

  pushInactiveItemToList(
    list: AttributeListBE[],
    idToAdd: number,
    descriptionToAdd
  ): void {
    if (list.findIndex((x) => x.Id == idToAdd) === -1) {
      let listItem: AttributeListBE = new AttributeListBE();
      listItem.Id = idToAdd;
      listItem.Description = descriptionToAdd;
      listItem.Active = false;
      list.push(listItem);
    }
  }

  setSelectedListItems(
    uiList: AttributeListBE[],
    materialList: AttributeListBE[]
  ) {
    uiList.forEach(function (item) {
      item.Selected = false;
    });
    materialList.forEach(function (item) {
      let inx = uiList.findIndex((x) => x.Id == item.Id);
      if (inx != -1) uiList[inx].Selected = true;
      else {
        uiList.push(item);
        uiList[uiList.length - 1].Selected = true;
      }
    });
  }

  // ----------------------------------------------------------
  // Fetch list data
  // ----------------------------------------------------------
  getPackagingTypes() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getPackagingTypes()
      .subscribe((returnObject) =>
        this.getPackagingTypesResponse(returnObject)
      );
  }

  getPackagingTypesResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getPackagingTypesResponse",
        returnObject.ErrorType
      );
    else this.packagingTypesList = returnObject.DataList;
  }

  getPackagingOwners() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getPackagingOwners()
      .subscribe((returnObject) =>
        this.getPackagingOwnersResponse(returnObject)
      );
  }

  getPackagingOwnersResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getPackagingOwnersResponse",
        returnObject.ErrorType
      );
    else this.packagingOwnersList = returnObject.DataList;
  }

  getReturnables() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getReturnables()
      .subscribe((returnObject) => this.getReturnablesResponse(returnObject));
  }

  getReturnablesResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getReturnablesResponse",
        returnObject.ErrorType
      );
    else this.returnablesList = returnObject.DataList;
  }

  getClassifications() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getClassifications()
      .subscribe((returnObject) =>
        this.getClassificationsResponse(returnObject)
      );
  }

  getClassificationsResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getClassificationsResponse",
        returnObject.ErrorType
      );
    else this.classificationsList = returnObject.DataList;
  }

  getDispatchers() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getDispatcherReceiver()
      .subscribe((returnObject) => this.getDispatchersResponse(returnObject));
  }

  getDispatchersResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getDispatchersResponse",
        returnObject.ErrorType
      );
    else this.dispatchersList = returnObject.DataList;
  }

  getWashingSuppliers() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getWashingSuppliers()
      .subscribe((returnObject) =>
        this.getWashingSuppliersResponse(returnObject)
      );
  }

  getWashingSuppliersResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getWashingSuppliersResponse",
        returnObject.ErrorType
      );
    else this.washingSuppliersList = returnObject.DataList;
  }

  getMainStores() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getMainStores()
      .subscribe((returnObject) => this.getMainStoresResponse(returnObject));
  }

  getMainStoresResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getMainStoresResponse",
        returnObject.ErrorType
      );
    else this.mainStoresList = returnObject.DataList;
  }

  getReceivers() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getDispatcherReceiver()
      .subscribe((returnObject) => this.getReceiversResponse(returnObject));
  }

  getReceiversResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getReceiversResponse",
        returnObject.ErrorType
      );
    else this.receiversList = returnObject.DataList;
  }

  getConsumingAreas() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getConsumingAreas()
      .subscribe((returnObject) =>
        this.getConsumingAreasResponse(returnObject)
      );
  }

  getConsumingAreasResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getConsumingAreasResponse",
        returnObject.ErrorType
      );
    else this.consumingAreasList = returnObject.DataList;
  }

  getRegions() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getRegions()
      .subscribe((returnObject) => this.getRegionsResponse(returnObject));
  }

  getRegionsResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getRegionsResponse",
        returnObject.ErrorType
      );
    else this.regionsList = returnObject.DataList;
  }

  getStorageConditions() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getStorageConditions()
      .subscribe((returnObject) =>
        this.getStorageConditionsResponse(returnObject)
      );
  }

  getStorageConditionsResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getStorageConditionsResponse",
        returnObject.ErrorType
      );
    else this.storageConditionList = returnObject.DataList;
  }

  loadSupplierList() {
    this.viewSupplierListSpinner = true;
    clearInterval(this.typeDelayTimer);
    this.errHandler.emitErrorObject(null);
    this.supplierService
      .searchSupplier(this.searchSupplierText)
      .subscribe((returnObject) => this.loadSupplierListResponse(returnObject));
  }

  loadSupplierListResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.loadSupplierListResponse",
        returnObject.ErrorType
      );
    else this.supplierList = returnObject.DataList;

    this.viewSupplierListSpinner = false;
  }

  saveMaterial() {
    this.showSpinner = true;

    this.material.ConsumingAreas = this.getSelectedListValues(
      this.consumingAreasList
    );
    this.material.Dispatchers = this.getSelectedListValues(
      this.dispatchersList
    );
    this.material.MainStores = this.getSelectedListValues(this.mainStoresList);
    this.material.Receivers = this.getSelectedListValues(this.receiversList);
    this.material.WashingSuppliers = this.getSelectedListValues(
      this.washingSuppliersList
    );
    this.material.MaterialCompositions = this.materialCompList;

    // Cant delete the picture in instruction because it will then disappear from screen.
    // Alas, we save the instruction in a temp var and remove the bit stream in PictureImage
    // before sending to server.
    let tmpMaterial: PackagingMaterialBE = JSON.parse(
      JSON.stringify(this.material)
    );
    tmpMaterial.Pictures.forEach(function (item) {
      item.PictureImage = null;
    });
    this.materialService
      .saveMaterial(tmpMaterial)
      .subscribe((returnObject) => this.saveMaterialResponse(returnObject));
  }

  saveMaterialResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.saveMaterialResponse",
        returnObject.ErrorType
      );
    } else {
      this.info("The material was saved successsfully");
      this.setLoadedValues(returnObject);
    }
    this.showSpinner = false;
  }

  deleteMaterial() {
    this.showSpinner = true;
    this.errHandler.emitErrorObject(null);
    this.materialService
      .deleteMaterial(this.material.Id)
      .subscribe((returnObject) => this.deleteMaterialResponse(returnObject));
  }

  deleteMaterialResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.deleteMaterialResponse",
        returnObject.ErrorType
      );
    } else {
      this.AfterDeleteRender(returnObject);
    }
    this.showSpinner = false;
  }

  AfterDeleteRender(returnObject: IReturnObject) {
    if (returnObject.DataList[0].Id == -1) {
      this.info("The material was deleted");
      this.selectedMaterialId = null;
      this.newMaterial();
    } else {
      this.info("The package material was scrapped");
      this.setLoadedValues(returnObject);
    }
  }

  getSelectedListValues(uiList: AttributeListBE[]): AttributeListBE[] {
    let newList: AttributeListBE[] = [];
    uiList.forEach(function (item) {
      if (item.Selected) newList.push({ ...item });
    });
    return newList;
  }

  // ----------------------------------------------------------
  // Search suppliers
  // ----------------------------------------------------------
  searchSuppTextChanged() {
    var that = this; // needed to preserve scope reference to this within setinterval function
    this.selectedSupplier = null;
    if (that.searchSupplierText.length >= 2) {
      that.viewSupplierList = true;

      // If this.typeDelayTimer is not nulll then the
      // user typed somthing new within time limit so reset timer
      if (that.typeDelayTimer != null) clearInterval(that.typeDelayTimer);

      that.typeDelayTimer = setInterval(function () {
        that.loadSupplierList();
      }, that.searchKeyStrokeDelay);
    } else {
      that.viewSupplierList = false;
      clearInterval(this.typeDelayTimer);
    }
  }

  startSupplierSearchListWithDelay() {
    var that = this;

    if (!that.viewSupplierList) {
      clearInterval(this.supplierSearchListDelayTimer);
      return;
    }

    if (that.supplierSearchListDelayTimer != null)
      clearInterval(that.supplierSearchListDelayTimer);

    that.supplierSearchListDelayTimer = setInterval(function () {
      that.finalizeHideSupplierSearchListWithDelay();
    }, that.searchListDelayTimerDelay);
  }

  finalizeHideSupplierSearchListWithDelay() {
    this.viewSupplierList = false;
    clearInterval(this.supplierSearchListDelayTimer);
  }

  hideSupplierSearchListWithDelay() {
    clearInterval(this.supplierSearchListDelayTimer);
    this.startSupplierSearchListWithDelay();
  }

  showSupplierSearchList() {
    if (this.searchSupplierText.length >= 2) {
      clearInterval(this.supplierSearchListDelayTimer);
      this.viewSupplierList = true;
    }
  }

  // ----------------------------------------------------------
  // Add / delete suppliers
  // ----------------------------------------------------------
  selectSupplier(supplier: SupplierListBE) {
    this.searchSupplierText = supplier.Supplier;
    this.selectedSupplier = supplier;
    clearInterval(this.supplierSearchListDelayTimer);
  }

  isNewSupplierButtonDisabled() {
    return this.selectedSupplier == null;
  }

  addSupplier() {
    let newSelection: MaterialSupplierBE = new MaterialSupplierBE();
    newSelection.SupplierId = this.selectedSupplier.Id;
    newSelection.SupplierNo = this.selectedSupplier.Supplier.split(" - ")[0];
    newSelection.SupplierName = this.selectedSupplier.Supplier.split(" - ")[1];
    this.material.Suppliers.push(newSelection);
    this.searchSupplierText = "";
    this.selectedSupplier = null;
    this.setDirty();
  }

  removeSupplier(supplierId: number) {
    let inx: number = this.material.Suppliers.findIndex(
      (x) => x.Id == supplierId
    );
    this.material.Suppliers.splice(inx, 1);
    this.setDirty();
  }

  // ----------------------------------------------------------
  // Actions
  // ----------------------------------------------------------
  onBtnBarButtonNotify(command: string, confirmDlg: any): void {
    if (command == "new") {
      this.pendingAction = this.newMaterial;
      this.countinueWithoutSave(confirmDlg);
    } else if (command == "preview") {
      this.previewInstruction();
    } else if (command == "save" && this.isContentValid(confirmDlg)) {
      this.saveMaterial();
    } else if (command == "activate" && this.isContentValid(confirmDlg)) {
      this.pendingAction = this.activateMaterial;
      this.openConfirmActivateDlg(confirmDlg);
    } else if (command == "duplicate") {
      this.pendingAction = this.duplicateMaterial;
      this.countinueWithoutSave(confirmDlg);
    } else if (command == "delete") {
      this.openConfirmDeleteDlg(confirmDlg);
    }
  }

  countinueWithoutSave(modal: any) {
    if (this.isDirty) this.confirmContinueWithoutSave(modal);
    else this.pendingAction();
  }

  duplicateMaterial: any = () => {
    this.pendingAction = null;
    this.duplicateMaterialData();
  };

  newMaterial: any = () => {
    this.pendingAction = null;
    this.setNewMaterialData();
  };

  activateMaterial() {
    this.material.StatusId = StatusEnum.Active;
    this.material.ResponsibleUserId = this.user.UserId;
    this.material.ResponsibleUserName = this.user.UserName;
    this.material.ResponsibleEmail=this.user.Email;
    this.material.ResponsibleUserDepartment = this.user.Department;
    this.saveMaterial();
  }

  disableWhenActive() {
    return this.isEditDisabled() || this.material.StatusId == StatusEnum.Active;
  }

  setNewMaterialData() {
    this.material = new PackagingMaterialBE();
    this.material.ResponsibleUserId = this.user.UserId;
    this.material.ResponsibleUserName = this.user.UserName;
    this.material.ResponsibleEmail=this.user.Email;
    this.material.ResponsibleUserDepartment = this.user.Department;
    this.material.InitialCreatorUserId = this.user.UserId;
    this.material.InitialCreatorUserName = this.user.UserName;
    this.material.InitialCreatorEmail=this.user.Email;
    this.material.InitialCreatorUserDepartment = this.user.Department;
    this.resetTmpArrayes();
    this.material.CreatedDate = new Date();
    this.orgName = "";
    this.nameExistsClass = "";
    this.newMaterialText = "NEW";
    this.isEditMode = true;
    this.pictureLabels = "";
    this.showMaterialSearchSpinner = false;
    this.materialCompList = [];
  }

  duplicateMaterialData() {
    this.newMaterialText = "NEW COPY OF: " + this.material.MHNo;
    this.material.MHNo = "";
    this.material.Id = -1;
    this.material.StatusId = StatusEnum.Preliminary;
    this.resetTmpArrayes();
    this.orgName = "";
    this.nameExistsClass = "";
    this.material.MHNo = "";
  }

  isContentValid(modal: any): boolean {
    if (
      !(
        this.material.MHNo.startsWith("PSCS") ||
        this.material.MHNo.startsWith("pscs")
      )
    ) {
      if (!(this.material.MHNo.startsWith("568") || this.material.MHNo.startsWith("569"))) {
        if (!this.isValidMaterialName()) {
          this.openOnSaveValidateDlg(
            modal,
            "Material name must consist of 7 letters and start with either (mh-)/(pscs) \n or 6 letters and start with (568, 569) and description at least one characters long"
          );
          return false;
        }
      } else {
        if (!this.isValidMaterialName568()) {
          this.openOnSaveValidateDlg(
            modal,
            "Material name must consist of 7 letters and start with either (mh-)/(pscs) \n or 6 letters and start with (568, 569) and description at least one characters long"
          );
          return false;
        }
      }
    } else {
      if (!this.isValidPSCSMaterialName()) {
        this.openOnSaveValidateDlg(
          modal,
          "Material name must consist of 7 letters and start with either (mh-)/(pscs) \nor 6 letters and start with (568) and description at least one characters long"
        );
        return false;
      }
    }

    if (!this.isValidListSelections()) {
      this.openOnSaveValidateDlg(
        modal,
        "XXX, YYYY and ZZZ must to be set to a value other than undefined"
      );
      return false;
    } else if (!this.isValidNumericValues()) {
      this.openOnSaveValidateDlg(
        modal,
        "Length, Width, Height and Weight must be numeric, please correct before save"
      );
      return false;
    } else if (!this.isValidOther()) {
      this.openOnSaveValidateDlg(
        modal,
        "Other info is not correct, plase fix xxxxx"
      );
      return false;
    }

    return true;
  }

  isValidOther(): boolean {
    return true;
  }

  isValidListSelections(): boolean {
    return true;
  }

  isValidMaterialName(): boolean {
    if (this.material.Id === -1) {
      let regexp = new RegExp("((mh-|MH-)[a-zA-Z0-9]{4}$)");
      return regexp.test(this.material.MHNo);
    } else {
      return (
        this.material.MHNo.length >= 2 && this.material.Description.length >= 1
      );
    }
  }

  // isValidMaterialName568(): boolean {
  //   if (this.material.Id === -1) {
  //     let regexp = new RegExp("((568)[a-zA-Z0-9]{3}$)");
  //     return regexp.test(this.material.MHNo);
  //   } else {
  //     return (
  //       this.material.MHNo.length >= 2 && this.material.Description.length >= 1
  //     );
  //   }
  // }

  isValidMaterialName568(): boolean {
    if (this.material.Id === -1) {
      // Accept both 568 and 569 as prefixes
      let regexp = new RegExp("((56[89])[a-zA-Z0-9]{3}$)");
      return regexp.test(this.material.MHNo);
    } else {
      return (
        this.material.MHNo.length >= 2 && this.material.Description.length >= 1
      );
    }
  }
  

  isValidPSCSMaterialName(): boolean {
    let regexp = new RegExp("((pscs|PSCS)[a-zA-Z0-9-]{3}$)");
    return regexp.test(this.material.MHNo);
  }

  isValidNumericValues(): boolean {
    let checkValues: boolean =
      Number.isNaN(this.material.OuterLength) ||
      Number.isNaN(this.material.OuterWidth) ||
      Number.isNaN(this.material.OuterHeight) ||
      Number.isNaN(this.material.Weight) ||
      Number.isNaN(this.material.Price);
    return !checkValues;
  }

  // ----------------------------------------------------------
  // Check if mhno exists when typing
  // ----------------------------------------------------------
  checkNameUnique() {
    if (this.material.MHNo.length < MIN_NAME_LENGTH) {
      this.nameExistsClass = "";
      return;
    }

    if (this.material.MHNo == this.orgName) {
      this.nameExistsClass = "";
      return;
    }

    this.materialService
      .mhnoExist(this.material.MHNo)
      .subscribe((nameExists) => this.checkNameUniqueResponse(nameExists));
  }

  checkNameUniqueResponse(nameExists: boolean) {
    if (nameExists) {
      this.nameExistsClass = "nameExist";
    } else {
      this.nameExistsClass = "";
    }
  }

  setDefaultBackColor() {
    this.nameExistsClass = "";
  }

  // ----------------------------------------------------------
  // Confirm dialog
  // ----------------------------------------------------------
  openOnSaveValidateDlg(modal: any, text: string) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "savefail";
    this.dialogBtnType = "info";
    this.dialogAppliesTo = "Package Material";
    this.confirmDlgText = text;
    this.dialogAppliesToId = this.material.Id;
    this.currentDlg = this.modalService.open(modal, { size: "sm" });
  }

  confirmContinueWithoutSave(modal: any) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "continuewithoutsave";
    this.dialogBtnType = "warning";
    this.dialogAppliesTo = "Package Material";
    this.dialogAppliesToId = this.material.Id;
    this.currentDlg = this.modalService.open(modal, { size: "sm" });
  }

  openConfirmDeleteDlg(modal: any) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "delete";
    this.dialogBtnType = "danger";
    this.dialogAppliesTo = "Package Material";
    this.dialogAppliesToId = this.material.Id;
    this.currentDlg = this.modalService.open(modal, { size: "sm" });
  }

  openConfirmActivateDlg(modal: any) {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "activate";
    this.dialogBtnType = "warning";
    this.dialogAppliesTo = "Package Material";
    this.dialogAppliesToId = this.material.Id;
    this.currentDlg = this.modalService.open(modal, { size: "sm" });
  }

  onConfirmDlgNotify(command: ConfirmResult): void {
    this.closeDlg();
    if (command.Action == "delete") {
      this.deleteMaterial();
    } else if (command.Action == "activate") {
      this.activateMaterial();
    } else if (command.Action == "continuewithoutsave") {
      if (this.pendingAction != null) this.pendingAction();
    } else if (command.Action == "cancel") {
      this.pendingAction = null;
    } else {
      this.pendingAction = null;
    }
  }

  // ----------------------------------------------------------
  // info
  // ----------------------------------------------------------
  info(message: string): void {
    this.errHandler.emitError(message, "", ErrorTypeEnum.Info);
  }

  previewInstruction() {
    //console.log();
    this.materialService
      .getPreviewPdf(this.material.Id, this.material.MHNo)
      .subscribe((returnObject) => this.previewMaterialResponse(returnObject));
  }

  previewMaterialResponse(returnObject: any) {
    window.open(
      this.config.get("apiUrl") +
      "/PackagingMaterial/GetPreviewPdfForMaterial/?materialId=" +
      this.material.Id +
      "&mhNo=" +
      this.material.MHNo,
      "_blank"
    );
  }

  // ----------------------------------------------------------
  // Images handling
  // ----------------------------------------------------------
  extractImages() {
    this.pictureIdS = [];
    ImageCommon.SetBase64Image(this.material.Pictures);
    this.material.Pictures.forEach((x) => this.pictureIdS.push(x.Id));
    this.pictureLabels = ImageCommon.setPictureLabels(this.material.Pictures);
    this.MHNOName = this.material.MHNo;
    this.piImageId = this.pictureIdS;
  }

  selectImageToMaterial(addedImage: any) {
    if (this.selectedImages.indexOf(addedImage.Id) === -1) {
      this.selectedImages.push(addedImage.Id);
      this.imageSearchResult.push(addedImage);
    } else {
      this.selectedImages.splice(this.selectedImages.indexOf(addedImage), 1);
      this.imageSearchResult.splice(
        this.imageSearchResult.indexOf(addedImage.Id),
        1
      );
      this.imageLibraryEvent = null;
    }
  }

  addImageToMaterial() {
    let that: PackagingMaterialComponent = this;
    this.selectedImages.forEach(function (item: number) {
      if (that.pictureIdS.indexOf(item) === -1) {
        var imageObj = that.imageSearchResult.find((x) => x.Id === item);
        that.material.Pictures.push(imageObj);
      }
    });

    this.refreshPictureIds();
    ImageCommon.setPictureLabels(this.material.Pictures);
    this.imageSearchResult = [];
    this.closeAddImageDlg();
    this.info("Image's added.");
    this.setDirty();
  }

  deleteImageFromMaterial(imageId: any) {
    ImageCommon.RemovePic(this.material.Pictures, imageId);
    this.refreshPictureIds();
    this.pictureLabels = ImageCommon.setPictureLabels(this.material.Pictures);
    this.info("The picture was removed from the material.");
    this.closeDlg();
    this.setDirty();
  }

  refreshPictureIds() {
    this.pictureIdS = [];
    this.material.Pictures.forEach((x) => this.pictureIdS.push(x.Id));
  }

  closeAddImageDlg() {
    this.imageSearchResult = [];
    this.selectedImages = [];
    this.closeDlg();
  }

  openAddImage(modal: any) {
    this.currentDlg = this.modalService.open(modal, { size: "lg" });
  }

  openDeleteImage(modal: any, pictureInfo: any) {
    this.deleteImageInfo = pictureInfo;
    this.currentDlg = this.modalService.open(modal, { size: "sm" });
  }

  countChange(event: PictureBe) {
    this.imageLibraryEvent = <PictureBe>event;
    this.selectImageToMaterial(this.imageLibraryEvent);
  }

  // ----------------------------------------------------------
  // MISC
  // ----------------------------------------------------------
  setDirty() {
    this.isDirty = true;
  }

  closeDlg() {
    this.currentDlg.close();
  }

  weightChanged() {
    this.material.WeightChanged = true;
    this.setDirty();
  }

  // ----------------------------------------------------------
  // SearchMaterial
  // ----------------------------------------------------------
  onSearchMaterialDialogExecute(dialogResult: PackagingMaterialListBE[]) {
    if (dialogResult == null) {
      this.closeDlg();
      return;
    }

    if (dialogResult.length > 0) {
      if (this.MHNOControlNameToSet == "ReplacingMHNO") {
        this.material.ReplacingMaterialId = dialogResult[0].Id;
        this.material.ReplacingMaterialMHNO = dialogResult[0].MHNo;
      } else {
        this.material.ReplacedByMaterialId = dialogResult[0].Id;
        this.material.ReplacedByMaterialMHNO = dialogResult[0].MHNo;
      }
      this.setDirty();
    }

    this.closeDlg();
  }

  onEditReplacingMHNO(modal: any) {
    this.MHNOControlNameToSet = "ReplacingMHNO";
    this.currentDlg = this.modalService.open(modal, { size: "sm" });
  }

  onEditReplacedByMHNO(modal: any) {
    this.MHNOControlNameToSet = "ReplacedByMHNO";
    this.currentDlg = this.modalService.open(modal, { size: "sm" });
  }

  onDeleteReplacingMHNO() {
    this.material.ReplacingMaterialId = null;
    this.material.ReplacingMaterialMHNO = "";
    this.setDirty();
  }

  onDeleteReplacedByMHNO() {
    this.material.ReplacedByMaterialId = null;
    this.material.ReplacedByMaterialMHNO = "";
    this.setDirty();
  }

  // ------------------------------------------------------
  //Access rights control
  // ------------------------------------------------------
  isBtnBarHidden(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin ||
        this.user.IsPackagingEngineer ||
        this.user.IsDeveloper) &&
      this.materialIdFromParentCtrl == null;

    return !gotAccess;
  }

  isBtnActivateDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin ||
        this.user.IsPackagingEngineer ||
        this.user.IsDeveloper) &&
      this.material != null &&
      this.material.Id != -1 &&
      this.material.StatusId == StatusEnum.Preliminary &&
      this.isEditMode &&
      !this.isDirty &&
      this.nameExistsClass != "nameExist";

    return !gotAccess;
  }

  isBtnNewDisabled(): boolean {
    let gotAccess: boolean =
      this.user.IsPackagingAdmin ||
     // this.user.IsPackagingEngineer ||
      this.user.IsDeveloper;

    return !gotAccess;
  }

  isBtnDuplicateDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin ||
        this.user.IsPackagingEngineer ||
        this.user.IsDeveloper) &&
      this.material != null &&
      this.material.Id != -1 &&
      this.isEditMode;

    return !gotAccess;
  }

  isBtnSaveDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin ||
        this.user.IsPackagingEngineer ||
        this.user.IsDeveloper) &&
      this.material != null &&
      (this.material.StatusId == StatusEnum.Preliminary ||
        this.material.StatusId == StatusEnum.Active || this.material.StatusId == StatusEnum.PhasingOut) &&
      this.isDirty &&
      this.isEditMode &&
      this.nameExistsClass != "nameExist";

    return !gotAccess;
  }

  isBtnDeleteDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin ||
        this.user.IsPackagingEngineer ||
        this.user.IsDeveloper) &&
      this.material != null &&
      this.material.Id != -1 &&
      this.isEditMode;

    return !gotAccess;
  }

  isBtnPreviewDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin ||
        this.user.IsPackagingEngineer ||
        this.user.IsTestPackager ||
        this.user.IsPartSupplierUser ||
        this.user.IsPurchaser ||
        this.user.IsScaniaUser ||
        this.user.IsDeveloper) &&
      !this.isDirty && // must be saved to be able to view PDF
      this.material != null;

    return !gotAccess;
  }

  isSearchHidden(): boolean {
    let gotAccess: boolean =
      this.user.IsPackagingAdmin ||
      this.user.IsScaniaUser ||
      this.user.IsPackagingEngineer ||
      this.user.IsTestPackager ||
      this.user.IsPartSupplierUser ||
      this.user.IsPurchaser ||
      this.user.IsDeveloper;

    return !gotAccess;
  }

  isStatusDisabled(): boolean {
    let gotAccess: boolean =
      this.user.IsPackagingAdmin && this.material != null;

    return !gotAccess;
  }

  isEditDisabled(): boolean {
    let gotAccess: boolean =
      (this.user.IsPackagingAdmin ||
        this.user.IsPackagingEngineer ||
        this.user.IsDeveloper) &&
      this.material != null &&
      (this.material.StatusId == StatusEnum.Preliminary ||
        this.material.StatusId == StatusEnum.Active || this.material.StatusId == StatusEnum.PhasingOut) &&
      this.materialIdFromParentCtrl == null;

    return !gotAccess;
  }

  isPriceHidden(): boolean {
    let gotAccess: boolean =
      this.user.IsPackagingAdmin ||
      this.user.IsPackagingEngineer ||
      this.user.IsPurchaser ||
      this.user.IsDeveloper;

    return !gotAccess;
  }

  canSeeSupplierInfo() {
    return !this.user.IsPartSupplierUser;
  }

  getMaterialList() {
    this.errHandler.emitErrorObject(null);
    this.materialService
      .getMaterialList()
      .subscribe((returnObject) => this.getMaterialsResponse(returnObject));
  }

  getMaterialsResponse(returnObject: IReturnObject) {
    if (returnObject.ErrorType != ErrorTypeEnum.NoError)
      this.errHandler.emitError(
        returnObject.ErrorMsg,
        "PackagingMaterialComponent.getMaterialsResponse",
        returnObject.ErrorType
      );
    else
     this.materialsList = returnObject.DataList;
  }

  add() {
    this.errHandler.emitErrorObject(null);

    if (!this.isValid()) return;
    let materialcomp = new MaterialCompositionBE();
    materialcomp.MaterialName = this.materialDescription;
    materialcomp.Weight = this.materialWeight;
    materialcomp.CompositionId = this.materialsList.find(x => x.Description == this.materialDescription).Id;
    materialcomp.CO2Impactperkg = this.materialsList.find(x => x.Description == this.materialDescription).CO2Impactperkg;

    this.materialCompList.push(materialcomp);
    this.material.Material = Array.prototype.map.call(this.materialCompList, s => s.MaterialName).join(", ");

    this.material.Weight += this.materialWeight;
    this.material.EstimatedkgCO2Weight += (this.materialWeight * 0.001) * materialcomp.CO2Impactperkg;
    this.material.EstimatedkgCO2Weight = Number(this.material.EstimatedkgCO2Weight.toPrecision(5));
    this.materialDescription = "";
    this.materialWeight = 0;
    this.co2Impactperkg = 0;
  }

  removeComposition(materialname: string, weight: number, co2Impactperkg: number) {
    this.errHandler.emitErrorObject(null);
    if (this.materialCompList.findIndex(
      (x) => x.MaterialName == materialname.trim()
    ) != -1) {
      this.material.Weight -= weight;
      this.material.EstimatedkgCO2Weight -= weight * 0.001 * co2Impactperkg;
      this.material.EstimatedkgCO2Weight = Number(this.material.EstimatedkgCO2Weight.toPrecision(5));
      this.materialCompList = this.materialCompList.filter(item => item.MaterialName != materialname);

      this.material.Material = Array.prototype.map.call(this.materialCompList, s => s.MaterialName).join(", ");

      this.confirmDlgText = "Material has been deleted successfully.";
      this.openValidateErrorDlg();
    }
  }

  isValid() {
    if (this.materialWeight <= 0) {
      this.confirmDlgText = "Weight should be greater than 0.";
      this.openValidateErrorDlg();
      return false;
    }
    else if (this.materialDescription == null || this.materialDescription == "") {
      this.confirmDlgText = "Please select material.";
      this.openValidateErrorDlg();
      return false;
    }
    else if (
      this.materialCompList.findIndex(
        (x) => x.MaterialName == this.materialDescription.trim()
      ) != -1 || this.materialCompList.findIndex(
        (x) => x.MaterialName == this.materialDescription.trim()
      ) > -1
    ) {
      this.confirmDlgText =
        "A record with the same material already exist, cant add.";
      this.openValidateErrorDlg();
      return false;
    }
    return true;
  }
  checkwholenumber(event:any)
  {
   const num =event.target.value;
   if(num.includes('.'))
   {
    event.target.value=num.split('.')[0];
   }
  }

  openValidateErrorDlg() {
    this.errHandler.emitErrorObject(null);
    this.dialogAction = "info";
    this.dialogBtnType = "info";
    this.dialogAppliesTo = "Material Composition";
    this.dialogAppliesToId = this.materialId;
    this.currentDlg = this.modalService.open(this.cdlg, { size: "sm" });
    this.showSpinner = false;
  }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-material/packaging-material.component.ts